/* eslint-disable no-console */
function printJoinUsMessage(url) {
  if (typeof window === 'undefined') return;

  console.log(`%c
  ..............................................................
  ..............................................................
  ................:+*####*+:.....******:.........-*****=........
  ...........:=*+.:-+#######*:...######-.........=#####+........
  .........=###+......-*######-..######-.........=#####+........
  .......:#####:........*#####+:.######-.........=#####+........
  .......*####*:........:######:.######-.........=#####+........
  ......:#####*:.........######:.######-.........=#####+........
  ......:#####*:.........######:.######-.........=#####+........
  ......:#####*:.........######:.######-.........=#####+........
  ......:#####*:.........######:.######-.........=#####=........
  ......:#####*:.........######:.-######.........=#####:........
  ......:#####*:.........######:..######*........*####-.........
  ......:#####*:.........######:..:#######=.....+##*-...........
  ......:#####*:.........######:...:+########*=::...............
  .......::::::..........::::::.......-=+*+=-...................
  ..............................................................
  ..............................................................`, 'color: #FFFFFF; background: #841CD4;');
  console.log(`%c Join us :) ${url}`, 'color: #FFFFFF; background: #841cd4;');
}

export default printJoinUsMessage;
